@if ({}; as STATE) {
  <main class="onboarding-form-map-dialog">
    <custom-modal-card>
      <ng-container header>
        <ng-container header>
          <default-modal-header
            title="Rechercher la position de votre siège sur la carte"
            description="Rechercher la localisation de votre siège en saisissant le lieu d'indication dans la barre de recherche"
          ></default-modal-header>
        </ng-container>
      </ng-container>
      <ng-container body>
        <article class="onboarding-form-map-dialog__map-wrapper">
          <div class="onboarding-form-map-dialog__search-container">
            <input
              #searchInput
              id="search-input"
              type="text"
              placeholder="Entrer un lieu"
            />
          </div>

          <section #mapContainer></section>
        </article>
      </ng-container>
      <ng-container footer>
        <button class="btn btn-primary" (click)="confirmPosition()">
          Confirmer la position
        </button>
      </ng-container>
    </custom-modal-card>
  </main>
}
